/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { FormControl, HFlow, Text } from 'bold-ui'
import { DateField, IdadeField, IdadeFieldModel } from 'components/form'
import { resolveValue } from 'components/form/final-form/useField'
import theme from 'config/theme'
import moment from 'moment'
import { useField, useFormState } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

export interface DataProblemaFieldModel {
  data?: LocalDate
  idade?: IdadeFieldModel
}

export interface DataProblemaFieldProps {
  name: MetaPath<DataProblemaFieldModel>
  label?: string
  dataNascimentoCidadao: LocalDate
}

export function DataProblemaField(props: DataProblemaFieldProps) {
  const { name, label, dataNascimentoCidadao } = props

  const { values: formValues } = useFormState({ subscription: { values: true } })
  const values = resolveValue(formValues, name) || {}

  const {
    input: { onChange: setData },
  } = useField(name.data.absolutePath())
  const {
    input: { onChange: setAnosIdade },
  } = useField(name.idade.anos.absolutePath())
  const {
    input: { onChange: setMesesIdade },
  } = useField(name.idade.meses.absolutePath())

  const handleDateBlur = () => {
    setAnosIdade(values?.data && moment(values.data).diff(moment(dataNascimentoCidadao), 'year'))
    setMesesIdade(values?.data && moment(values.data).diff(moment(dataNascimentoCidadao), 'months') % 12)
  }

  const handleIdadeBlur = () => {
    setData(
      (values?.idade?.meses || values?.idade?.anos) &&
        moment(dataNascimentoCidadao)
          .add(values.idade.meses, 'month')
          .add(values.idade.anos, 'year')
          .format('YYYY-MM-DD')
          .toString()
    )
  }

  return (
    <FormControl label={label}>
      <HFlow
        style={css`
          border: 1px solid ${theme.pallete.gray.c80};
          padding: 1rem;
          width: 28.5rem;
        `}
      >
        <DateField
          name={name.data}
          label='Data'
          clearable
          style={css`
            min-width: 10.5rem;
          `}
          onBlur={handleDateBlur}
        />
        <FormControl label={<span>&nbsp;</span>}>
          <Text
            fontWeight='bold'
            style={css`
              line-height: 2rem;
            `}
          >
            OU
          </Text>
        </FormControl>
        <IdadeField
          style={css`
            min-width: 12.5rem;
          `}
          name={name.idade}
          label='Idade'
          onBlur={handleIdadeBlur}
        />
      </HFlow>
    </FormControl>
  )
}
